// removed by extract-text-webpack-plugin
module.exports = {"horizontal-slider":"horizontal-slider","vertical-slider":"vertical-slider","example-thumb":"example-thumb","active":"active","example-track":"example-track","example-track-1":"example-track-1","example-track-2":"example-track-2","example-mark":"example-mark"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/Slider.css
// module id = 1042
// module chunks = 0